import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';

var Config = require('../../../config');

class ModalCancel extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.state = {
			show: false,
			id:"",
			cancel:false,
			delete:false,
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(id){
		this.setState({show:true, id:id});
	}

	handleClose(){
		this.setState({show:false, id:"", cancel:false, delete:false});
	}

	handleChange(e){
		if(e.target.name === 'delete'){
			this.setState({
				delete: e.target.checked ? true : false,
				cancel:false
			})
		}else{
			this.setState({
				delete: false,
				cancel:e.target.checked ? true : false,
			})
		}
	}

	handleSubmit(e){
		e.preventDefault();
		var url = "", msg = "";
		if(this.state.delete){
			url = 'petitions/'+this.state.id;
			msg = "El registro se elimino correctamente";
		}

		if(this.state.cancel){
			url = 'petitions/cancel/'+this.state.id;
			msg = "El registro se cancelo correctamente";
		}

		if(!this.state.delete && !this.state.cancel){
			swal('Error', 'Debe seleccionar una opción', 'error');
		}else{
			this.props.waiting.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+url, {
	  			method : 'delete',
	  			headers: new Headers({
	  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
	  				'Accept'		: 'application/json',
	  				'Content-Type'	: 'application/json'
	  			})
	  		}).then(res => {
	  			this.props.waiting.handleClose();
	  			if(res.ok){
	  				return res.json();
	  			}else{
	  				res.text().then((msg)=>{
	  					swal("Error", msg, 'error');
	  				})
	  			}
	  		})
	  		.then(response=>{
	  			if(response !== undefined){
	  				this.props.getList();
					this.handleClose();
	  				swal('Success', msg, 'success');
	  			}	
	  		})
		}
			
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div style={{color:'orange', textAlign:'center'}}>
				        		<i className="fa fa-exclamation fa-5x" aria-hidden="true"></i>
				        	</div>
		        		</div>
		        		<div className="col-xs-12" style={{textAlign:'center'}}>
		        			<h2>¿Está Seguro?</h2>
		        		</div>
		        		<div className="col-xs-12" style={{textAlign:'center'}}>
		        			<h4>Seleccione una opción</h4>
		        		</div>
		        		<div className="col-xs-12 col-sm-offset-2">
		        			<input type="checkbox" name="delete" id="delete" value={this.state.delete} onChange={this.handleChange}
		        				checked={this.state.delete} />
		        			<span style={{marginLeft:'8px'}}>Eliminar Petición</span>
		        		</div>
		        		<div className="col-xs-12 col-sm-offset-2">
		        			<input type="checkbox" name="cancel" id="cancel" value={this.state.cancel} onChange={this.handleChange}
		        				checked={this.state.cancel}/>
		        			<span style={{marginLeft:'8px'}}>Cancelar Petición</span>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer style={{textAlign:'center'}}>
		        	<FlatButton primary={true} label={t('content.generics.buttons.submit')}  onClick={this.handleSubmit}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalCancel)